import { api } from "services"

export async function deleteDocument(payload: any) {
    const { data } = await api.delete(`reverse-logistics/${payload.collectId}/delete-document/${payload.docId}`)
    return data;
}
